import { RecordingFlag } from 'types/schema.type';

/**
 * project_management#580: the selectable recording flags.
 *
 * The list is the generated schema enum, in SDL order. It used to be fetched
 * at runtime by introspecting the enum on the server; introspection is off in
 * production since #532, which left every flag filter and selector empty. The
 * enum is already the contract the app is built against (codegen), so a new
 * flag means a codegen refresh and a frontend release, never a network call.
 */
export const RECORDING_FLAG_OPTIONS: RecordingFlag[] = Object.values(RecordingFlag);

const recordingFlagHelpText = `FULLY_ANNOTATED_PROFESSIONALLY:
Pilnai anotuoti Ekg įrašai su duomenų interpretatoriaus sudėtomis žymėmis - ekg  įrašas vizualiai peržiūrėtas duomenų interpretatoriaus (kardiologas ar ....), ir kur reikia - sudėtos pūpsnių visos 5 žymės: N, S, V, F, U. Tai duomenys, kurių labiausiai reikia tiek algoritmų mokymui, tiek ir tikslumo įvertinimui.
PSEUDO_ANNOTATED:
Pseudo anotuoti  Ekg įrašai  -  įrašus su automatiškai sudėtomis pūpsnių žymėmis N vizualiai peržiūri ir žymes ties ekstrasistolėmis pakeičia iš N į E neprofesionalus duomenų interpretatorius (pvz. Ignas),  turime 12 įrašų, tikimės pasidaryti tokių įrašų dar papildomai artimiausioje ateityje.
ANNOTATED_BY_ML:
Automatiškai anotuoti Ekg įrašai -   įrašai su automatiškai sudėtomis pūpsnių žymėmis N pateikiami kompiuterio programai, kuri atpažįsta nenormalius pūpsnius ir žymes ties jais pakeičia iš N į E. Atpažinimo algoritmas dar vis konstruojamas.
UNCHECKED:
Neanotuoti Ekg įrašai su žymių failais, kuriuose yra tik automatinės pūpsnių žymės N,  niekas šių įrašų vizualiai neperžiūrėjo.
BAD_QUALITY:
Nekokybiški Ekg įrašai, pvz. turintys daug triukšmų ar įrašyti neaiškiomis sąlygomis, arba yra dar kokios tai aplinkybės, kurios neleidžia traktuoti įrašą, kaip priimtiną.
NOISES_ANNOTATED:
Įraše rankiniu būdu sužymėti triukšminiai intervalai.`;

export { recordingFlagHelpText };
